export const SKIP_PROMO_URL_QUERY = 'skipPromo';

export const OPEN_ACCESS_DIALOG_QUERY = '__open-access-dialog';
export const OPEN_ACCESS_APPROVE_QUERY = '__open-access-approve';

export const BACKOFFICE_QUERY = 'backoffice';
export const PROMO_VERSION_QUERY = 'versionId';
